import React, { useState } from "react";
import { Button, Box, TextInput, Accordion } from "@mantine/core";
import Checkbox from '@mui/material/Checkbox';
import { ArrowLeft } from "tabler-icons-react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { FormControlLabel, FormGroup } from "@mui/material";

export function Item({ filter, index, selected, ...props }: any) {

    const [parent, setParent] = useState(
        filter.parent == null ? " " : filter.parent
    );

    const handleChange = (
        event: any
    ) => {
        const columnName = event.target.name;
        const headerValue = event.target.value;
        props.reportUI.globalFilter["selectedFilter"].list.filter((obj: any) => obj.id === columnName.substring(6))
            .map((obj: any) => {
                obj.parent = headerValue;
            })
        setParent(headerValue)
    };

    const handleChangeMulti = (
        event: any
    ) => {
        const columnName = event.target.name;
        props.reportUI.globalFilter["selectedFilter"].list.filter((obj: any) => obj.id === columnName.substring(5))
            .map((obj: any) => {
                if (event.target.checked) {
                    obj.multiSelect = true;
                } else {
                    obj.multiSelect = false;
                }
            })
        props.setReportUI(props.reportUI)
    };
    const changeColumn = (selected: boolean) => {
        //creates a copy of the column state
        let updatedColumns = { ...props.reportUI.globalFilter };
        //addColumnsInRequestBody(updatedColumns, selected, index);
        if (!selected) {
            const removedElement = props.reportUI.globalFilter["globalFilter"].list.splice(
                index,
                1
            );
            updatedColumns["selectedFilter"].list.push(removedElement[0]);
        } else {
            const removedElement = props.reportUI.globalFilter["selectedFilter"].list.splice(
                index,
                1
            );
            updatedColumns["globalFilter"].list.push(removedElement[0]);
        }
        props.setReportUI(props.reportUI);
        props.setReportState((currentState: any) => ({
            ...currentState,
            validationErrors: currentState.validationErrors.filter(
                (er: any) => er.property !== "simpleReportError"
            ),
        }));
    };

    const addColumnsInRequestBody = (object: any, selected: any, index: number) => {
        let copyOfReportInfo = { ...props.reportInfo };
        if (!props.reportInfo.extendedAttributes) {
            copyOfReportInfo.extendedAttributes = { headers: {} };
        }
        if (!selected) {
            let columnName = object["globalFilter"]["list"][index];
            copyOfReportInfo.extendedAttributes.headers[columnName] = columnName;
        } else {
            let columnName = object["selectedFilter"]["list"][index];
            delete copyOfReportInfo.extendedAttributes.headers[columnName];
        }

        props.setReportInfo(copyOfReportInfo);
    };

    const multiSelect = "Multi Select";

    function AccordionRow(props: any) {
        return (
            <Accordion iconPosition="right" transitionDuration={500}>
                <Accordion.Item label={props.filter.lable} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <TextField
                    select
                    variant="outlined"
                    value={parent}
                    name={"parent"+props.filter.id}
                    label="Parent Filter:"
                    sx={{ m: 1, width: "100%" }}
                    onChange={(e) =>
                        handleChange(e)
                    }
                    SelectProps={{
                        readOnly:
                            props.reportInfo.viewEditStatus === "VIEW" ? true : false,
                        native: false,
                    }}
                    placeholder="Select parent filter"
                    // helperText="Select parent filter"
                >
                    {([{lable:"Select",id:" "},...props.reportUI.globalFilter.allFilter.list]).map((option: any) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.lable}
                        </MenuItem>
                    ))}
                </TextField>

                <FormGroup>
                    <FormControlLabel control={<Checkbox
                        defaultChecked={props.filter.multiSelect}
                        onChange={(e) =>
                        handleChangeMulti(e)
                    }
                        name={"multi" + props.filter.id}
                    />} label={multiSelect} />
                </FormGroup>
                </Accordion.Item>
  </Accordion>
        );
    }

    return (<div
        className="item"
        onClick={() => !selected && changeColumn(selected) }
    >
        {!selected &&
            <div>
                {filter.lable}
            </div>}

        {console.log(filter.lable)}

        {selected && (
            <Box
                sx={() => ({
                    display: "flex",
                })}
            >
                <ArrowLeft
                    onClick={(e) => {
                        e.stopPropagation();
                        changeColumn(selected);
                    }}
                    size={24}
                    strokeWidth={2}
                    color={"black"}
                />
                <AccordionRow filter={filter} {...props} />
            </Box>
        )}
    </div>);
}